import { useEffect, useState } from "react";
import Header from "./components/Header";
import Hero from "./components/Hero";
import Features from "./components/Features";
import Guide from "./components/Guide";
import Scenes from "./components/Scenes";
import Channels from "./components/Channels";
import Reviews from "./components/Reviews";
import Faq from "./components/Faq";
import Subscribe from "./components/Subscribe";
import Footer from "./components/Footer";
import InlineSeo from "./components/InlineSeo";

function BackToTop() {
  const [show, setShow] = useState(false);

  useEffect(() => {
    const onScroll = () => setShow(window.scrollY > 600);
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  if (!show) return null;

  return (
    <button
      type="button"
      aria-label="返回顶部"
      onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
      className="fixed bottom-6 right-6 z-40 flex h-11 w-11 items-center justify-center rounded-full bg-primary-500 text-background-50 shadow-lift transition-colors hover:bg-primary-600"
    >
      <i className="ri-arrow-up-line text-xl" aria-hidden="true"></i>
    </button>
  );
}

export default function Home() {
  return (
    <>
      <InlineSeo />
      <Header />
      <main>
        <Hero />
        <Features />
        <Guide />
        <Scenes />
        <Channels />
        <Reviews />
        <Faq />
        <Subscribe />
      </main>
      <Footer />
      <BackToTop />
    </>
  );
}